import { RedoTextInput } from "@redotech/arbiter/input/redo-text-input";
import { InputSchema, groupInput, input } from "@redotech/ui/form";
import { nonEmptyValidator } from "@redotech/ui/validators";
import { memo } from "react";

export const UPSCarrierInput = groupInput({
  accountNumber: input<string>({ validator: nonEmptyValidator }),
});

export type UPSCarrierValue = InputSchema.Value<typeof UPSCarrierInput>;

export type UPSCarrierForm = InputSchema.Input<typeof UPSCarrierInput>;

export const upsCarrierDefault = (): UPSCarrierValue => ({ accountNumber: "" });

export const CreateUPSCarrierForm = memo(function CreateUPSCarrierForm({
  carrierInput,
}: {
  carrierInput: UPSCarrierForm;
}) {
  return (
    <RedoTextInput
      label="Account number"
      placeholder=""
      setValue={carrierInput.inputs.accountNumber.setValue}
      value={carrierInput.inputs.accountNumber.value}
    />
  );
});

// UPS SurePost form uses the same input structure as regular UPS
export const UPSSurepostCarrierInput = UPSCarrierInput;
export type UPSSurepostCarrierValue = UPSCarrierValue;
export type UPSSurepostCarrierForm = UPSCarrierForm;
export const upsSurepostCarrierDefault = upsCarrierDefault;

export const CreateUPSSurepostCarrierForm = memo(
  function CreateUPSSurepostCarrierForm({
    carrierInput,
  }: {
    carrierInput: UPSSurepostCarrierForm;
  }) {
    return (
      <RedoTextInput
        label="Account number"
        placeholder=""
        setValue={carrierInput.inputs.accountNumber.setValue}
        value={carrierInput.inputs.accountNumber.value}
      />
    );
  },
);
